import { g as getDocumentElement } from './getDocumentElement-CF55JRdX.js';
import { g as getComputedStyle } from './getComputedStyle-cPuW_mTw.js';
import { g as getWindowScrollBarX } from './getWindowScrollBarX-D_nS-TWC.js';
import { g as getWindowScroll } from './getWindowScroll-E89-q1-1.js';
import { m as max } from '../utils/math-DYbrqK2d.js';

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

export { getDocumentRect as g };
//# sourceMappingURL=getDocumentRect-gL9bXwKJ.js.map
